import { Waypoint } from 'react-waypoint'
import React, { useCallback, useEffect, useRef } from 'react'
import './styles.scss'
import { useSpring, animated as a } from 'react-spring'

export function Cover(props: {
  onLeave: (event: Waypoint.CallbackArgs) => void
}) {
  const coverSegment = useRef<HTMLDivElement>(null)
  const [{ scrollTop }, set] = useSpring(() => ({
    scrollTop: 0,
    immediate: true
  }))
  const textPosition = scrollTop.interpolate(val => `translateY(${val * 30}vh)`)
  const koeppelPosition = scrollTop.interpolate(
    val => `scale(${val * 0.6 + 0.6}) translate(${val * 10 - 50}%, 0)`
  )
  const sandersPosition = scrollTop.interpolate(
    val => `scale(${val * 0.6 + 0.6}) translate(40%, 0)`
  )
  const onScroll = useCallback(e => {
    if (e.target.scrollingElement && coverSegment.current) {
      set({
        scrollTop:
          e.target.scrollingElement.scrollTop /
          coverSegment.current.clientHeight
      })
    }
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <div
      className='ui vertical segment'
      id='cover'
      ref={coverSegment}
      style={{ backgroundImage: `url(${require('./symbols.png')})` }}
    >
      <a.div style={{ transform: textPosition }} className='ui text container'>
        <h1 className='ui header'>
          Êtes-vous populiste?
          <div className='sub header'>
            Répondez à vingt questions pour vous comparer aux dirigeants de la
            planète, aux politiciens suisses et à nos lecteurs.
          </div>
        </h1>

        <Waypoint scrollableAncestor={window} onLeave={props.onLeave} />

        <div className='ta author'>
          Philippe Zweifel et Kaspar Manz, équipe interactive (TA)
        </div>
      </a.div>

      <a.img
        style={{
          transform: sandersPosition,
          shapeOutside: `url(${require('./sanders.png')})`
        }}
        src={require('./sanders.png')}
        alt='Bernie Sanders mit geballter Faust während einer Rede.'
        className={'sanders'}
      />
      <a.img
        style={{ transform: koeppelPosition }}
        src={require('./koeppel.png')}
        alt='Roger Köppel während einer Rede, ebenfalls mit geballter Faust'
        className={'koeppel'}
      />
    </div>
  )
}
